export const toJsonHard = <T>(value: T): T => JSON.parse(JSON.stringify(value));
